
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./platforms.chrome.cjs.production.min.js')
} else {
  module.exports = require('./platforms.chrome.cjs.development.js')
}
